export default (str) => (str.length === 1 ? '0' : '') + str;
